import enquire from 'enquire.js';
import 'owl.carousel';
import breakpoints from '../breakpoints';

const InsurerSummary = class {

    constructor() {
        this.$el = $('.js-insurer-summary');

        enquire.register(breakpoints.palm, {

            match: () => {
                this.$el.addClass('owl-carousel');
                this.$el.owlCarousel({
                    stagePadding: 30,
                    loop: true,
                    items: 1,
                    dots: false,
                });
            },

            unmatch: () => {
                this.$el.removeClass('owl-carousel');
                this.$el.owlCarousel().trigger('destroy.owl.carousel');
            },
        });
    }

};

new InsurerSummary();
